import bFormCheckboxGroup from 'bootstrap-vue/es/components/form-checkbox/form-checkbox-group';

var pyFormCheckboxGroup = {
  extends: bFormCheckboxGroup
};

export default pyFormCheckboxGroup;


